export default {
    MENU: "@sollar_menu",
    RIGHTS: "@sollar_rights",
    INTEGRATION: "@sollar_integration",
    INTEGRATION_NAME: "@sollar_integration_name",
    INTEGRATION_TOKEN: "@thcs_integration_token",
    INTEGRATION_TIME_ZONE: "@sollar_integration_time_zone"
}
